export const constants: any = {
  'N/A': 'N/A',
  Day: 'Day',
  Last: 'Last'
}
